// @ts-check
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref, watch } from 'vue'
import { useUserStore } from "../pages/user/stores/user";
import http from "../api/http";

export const useSiteMenuStore = defineStore('siteMenu', () => {
    const menuList = ref([])

    const siteMenuInStorage = sessionStorage.getItem('siteMenu')
    if (siteMenuInStorage) {
        menuList.value = JSON.parse(siteMenuInStorage)
    }

    watch(() => menuList, (state) => {
        sessionStorage.setItem('siteMenu', JSON.stringify(menuList.value))
    }, { deep: true })

    const getSiteMenu = () => {
        const { user } = useUserStore();
        http.get(`/system/menu/retrieveAll?loginYn=${ user.userCd ? 'Y' : 'N'}`)
            .then((res) => {
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    setMenuList(result);
                }
            })
            .catch( (error) =>  {
                console.log(error);
            });
    }

    // setUser simple function
    function setMenuList (list) {
        menuList.value = list;
    }

    const mobileMatchingMenuIdList = [4, 18, 88, 89];

    const findMenuUrlsByIds = (menuIds, menus = menuList.value, result = []) => {
        menus.forEach(menu => {
            if (menuIds.indexOf(menu.menuId) > -1 && menu.menuUrl) {
                result.push(menu.menuUrl);
            }
            if (menu.child && menu.child.length > 0) {
                findMenuUrlsByIds(menuIds, menu.child, result);
            }
        });
        return result;
    };

    const isMobileRestrictedUrl = (fullPath) => {
        const restrictedUrls = findMenuUrlsByIds(mobileMatchingMenuIdList);
        return restrictedUrls.some(url => fullPath.indexOf(url) > -1);
    };

    return {
        menuList,
        setMenuList,
        getSiteMenu,
        isMobileRestrictedUrl,
        mobileMatchingMenuIdList
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useSiteMenuStore, import.meta.hot))
}
